<template>
  <footer class="border-t border-gray-200 bg-white/50 backdrop-blur-sm">
    <div class="container mx-auto px-4 py-8">
      <div class="grid md:grid-cols-4 gap-8">
        <!-- Logo和描述 -->
        <div>
          <div class="flex items-center gap-2 mb-4">
            <span class="text-3xl">🎯</span>
            <span class="font-bold text-psychology-primary">霍兰德职业兴趣测试</span>
          </div>
          <p class="text-sm text-gray-600">
            基于John Holland教授的RIASEC理论，通过90道科学问题，从六个维度分析你的职业兴趣，精准计算Holland Code，为你推荐最适合的专业方向和职业发展路径。
          </p>
        </div>

        <!-- 测试相关 -->
        <div>
          <h4 class="font-semibold mb-3">测试相关</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <router-link to="/assessment/start" class="hover:text-psychology-primary">开始测试</router-link>
            </li>
            <li>
              <router-link to="/history" class="hover:text-psychology-primary">历史记录</router-link>
            </li>
            <li>
              <router-link to="/guide" class="hover:text-psychology-primary">测试说明</router-link>
            </li>
          </ul>
        </div>

        <!-- 资源 -->
        <div>
          <h4 class="font-semibold mb-3">资源</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <router-link to="/guide" class="hover:text-psychology-primary">测试说明</router-link>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">隐私政策</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">关于我们</a>
            </li>
          </ul>
        </div>

        <!-- 帮助 -->
        <div>
          <h4 class="font-semibold mb-3">帮助</h4>
          <ul class="space-y-2 text-sm text-gray-600">
            <li>
              <a href="#" class="hover:text-psychology-primary">常见问题</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">使用技巧</a>
            </li>
            <li>
              <a href="#" class="hover:text-psychology-primary">反馈建议</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
        <p>© 2025 霍兰德职业兴趣测试. 科学的职业兴趣测试工具，帮助你了解职业兴趣和发展方向。</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterSection'
}
</script>

